<template>
  <div :class="{ 'my-4': alerts.length > 0 }">
    <Alert
      v-for="alert in alerts"
      :key="alert.id"
      :id="alert.id"
      :type="alert.type"
      :dismissible="alert.dismissible"
      :content="alert.content"
      :htmlContent="alert.htmlContent"
      :contentKey="alert.contentKey"
      :htmlContentKey="alert.htmlContentKey"
      :htmlContentParams="alert.htmlContentParams"
      :details="alert.details"
    >
    </Alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Alert from '@/components/Alert'

export default {
  name: 'Alerts',
  components: { Alert },
  computed: {
    ...mapState('alerts', ['alerts']),
  },
}
</script>
